<script setup lang="ts">
import { useDateRangeFilter } from "@/composables/filters/date-range-filter";
import { computed, inject } from "vue";
import type { PagingFilter } from "@/composables/filters/paging-filter";
import { pagingFilterSymbol } from "@/plugins/ContentFiltersPlugin";
import { marketHolidayDates } from "@tmi/utils/date-time";
import { useRoute } from "vue-router";

const {
  datesFilter,
  defaultFinalJSDate
} = useDateRangeFilter();

const route = useRoute();
const isWebinarListing = computed< boolean >( () => route.path.toLowerCase().includes( "webinar" ) );
const maxSelectableDate = computed< Date >( () => {
  if ( !isWebinarListing.value ) {
    return defaultFinalJSDate;
  }

  const oneMonthAhead = new Date( defaultFinalJSDate );
  oneMonthAhead.setMonth( oneMonthAhead.getMonth() + 1 );
  return oneMonthAhead;
} );

const dateFilterPlaceholder = computed< string >( () => {
  return isWebinarListing.value
    ? "Filter by Webinar Date (includes next month)"
    : "Filter by Published Date";
} );

function disabledDate( date: Date ): boolean {
  return date > maxSelectableDate.value;
}

const JSDateSunday = 0;
const JSDateSaturday = 6;
const disabledDayOfWeek: number[] = [ JSDateSunday, JSDateSaturday ];

const pagingFilter = inject< PagingFilter >( pagingFilterSymbol ) as PagingFilter;
function resetPageNumber() {
  pagingFilter?.resetPageNumber();
}
</script>

<template>
  <DatePicker
      @date-select="resetPageNumber"
      v-model="datesFilter"
      :disabled-dates="marketHolidayDates"
      :disabled-days="disabledDayOfWeek"
      dateFormat="m/d/yy"
      selectionMode="range"
      :placeholder="dateFilterPlaceholder"
      class="w-full"
      showIcon
      hideOnRangeSelection
  />
</template>
